import { formatDate } from '../../../utils/format-date.util';

import type {
  ResolverParameters,
  ResolverResult,
} from '../types/resolvers.type';

export const useDateCourante = ({
  enabled,
}: Readonly<ResolverParameters>): ResolverResult<string> => {
  if (!enabled) {
    return {
      data: undefined,
      error: null,
      isSuccess: false,
      isLoading: false,
    };
  }

  return {
    data: { generated: formatDate(new Date()) },
    error: null,
    isSuccess: true,
    isLoading: false,
  };
};
